import React from "react";

import { type TopLevelDataObj } from "@hsl/fund-explorer/types";

import { type Config, type TabConfig } from "../../../config/types";
import useListingsData from "../../../hooks/useListingsData";
import Table from "../Table";

interface Props {
    shareClasses: string[];
    config: Config;
    tab: TabConfig;
    groupShareClasses?: boolean;
}

const ListingsTabView = ({ tab, config, shareClasses }: Props) => {
    const listingsData = useListingsData(shareClasses);
    return (
        <>
            {Object.keys(listingsData).map((shareClass) => (
                <div key={shareClass}>
                    <div className="text-core-blue border-platinum mt-2 border-b-2 py-2 text-sm font-medium">
                        {shareClass} ETF Class
                    </div>
                    <Table
                        tab={tab}
                        config={config}
                        data={
                            listingsData[
                                shareClass
                            ] as unknown as TopLevelDataObj[]
                        }
                    />
                </div>
            ))}
        </>
    );
};

export default ListingsTabView;
